import { useContext,useState, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Image } from "react-bootstrap";
import Navigation from "../Navbar";
import api from "../Api/Api";
import Spinner from "../../Components/Spinner";
import { MdAddAPhoto,MdOutlinePhotoCamera } from "react-icons/md";
import { RiArrowGoBackLine } from "react-icons/ri";
import { BsFillSendArrowUpFill } from "react-icons/bs";
import { GiNextButton } from "react-icons/gi";
import { IoIosSkipBackward } from "react-icons/io";
import './index.scss';
import { UserContext } from '../../context/UserContext';

const WebcamCapture = () => {
  const {user} = useContext(UserContext) 
  const location = useLocation();
  const orcamento = location.state;
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [showinit, setShowinit] = useState(true)
  const [showcamera, setShowcamera] = useState(false)
  const [showfoto, setShowfoto] = useState(false)
  const [showvisualizar, setShowvisualizar] = useState(false)
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const [ShowLoading, setShowLoading] = useState(false)
  const [getQuantfiles, setGetquantfiles] = useState(false)
  const [quantfiles, setQuantfiles] = useState(0)
  const [url,setUrl] = useState('')
  const [nfoto, setNfoto] = useState(1)
  const credentials = btoa(`${user.userRest}:${user.passRest}`); 
  const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      "Access-Control-Allow-Origin": "*",
      "User-Agent": "PneusBrasil",
      "Accept": "application/json",
      'Authorization': `Basic ${credentials}`
  } 
  async function QuantFiles(Orcamento: string) {
    setTimeout(() => {
      setShowLoading(true)
      setGetquantfiles(true)
      api.get('Getimagens?Orcamento='+Orcamento,{headers})
      .then(response => {
            if (response.data.Fotos.length > 0 ){     
                setQuantfiles(response.data.Fotos[0]['arqs'])
                setShowLoading(false)           
            }else{
                setShowLoading(false)
            }                                   
      });
    }, 10 );
  }
  async function saveFile(imagem: any, Orcamento: string) {
    setShowLoading(true)
    let qunatf = Number(quantfiles) + 1
    const url = 'DOWNLOAD_FILE?Orcamento='+Orcamento+'&idfoto='+qunatf+'&Origem=Entrada';
    // const headers = {
    //     'Content-Type': 'application/json;charset=UTF-8',
    //     "Access-Control-Allow-Origin": "*",
    //     "User-Agent": "PneusBrasil",
    //     "Accept": "*/*",
    //     'Authorization': `Basic ${credentials}`,
    //   } 
      api.post(url,imagem.toString('binary'), {headers})
      .then(function (response) {
          if(response.data['info'] === 'erro'){
              setShowLoading(false)
              alert('imagem não gravada, foto: '+ response.data['codigo'])
          }  
          if(response.data['info'] === 'criado'){ 
              setShowLoading(false)
              alert('Imagem gravada com sucesso, foto: '+ response.data['codigo'] )
              setCapturedImage(null); // Reset captured image
              setShowcamera(false)
              setShowfoto(false)
              setShowinit(true)
              QuantFiles(orcamento)
              //setCadok(true)               
          }                       
      })
      .catch(function (error) {
          console.error(error);
          setShowLoading(false)
          alert('Alert: Erro de conexão com servidor! ')
      });     
  }  

  const startWebcam = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: 'environment'
        } 
      });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
      setShowcamera(true)
      setShowinit(false)
      setShowvisualizar(false)
      setMediaStream(stream);
    } catch (error) {
      console.error("Error accessing webcam", error);
    }
  };

  // Function to stop the webcam
  const stopWebcam = () => {
    if (mediaStream) {
      mediaStream.getTracks().forEach((track) => {
        track.stop();
      });
      setMediaStream(null);
    }
  };

  const captureImage = () => {
    if (videoRef.current && canvasRef.current) {
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const context = canvas.getContext("2d");

      // Set canvas dimensions to match video stream
      if (context && video.videoWidth && video.videoHeight) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;

        // Draw video frame onto canvas
        context.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Get image data URL from canvas
        const imageDataUrl = canvas.toDataURL("image/jpeg");
        // Set the captured image
        setCapturedImage(imageDataUrl);
        setShowcamera(false)
        setShowfoto(true)
        setShowvisualizar(false)
        // Stop the webcam
        stopWebcam();

        // You can do something with the captured image here, like save it to state or send it to a server
      }
    }
  };

  // Function to reset state (clear media stream and refs)
  const resetState = () => {
    startWebcam()
    setCapturedImage(null); // Reset captured image
    setShowfoto(false)
    setShowvisualizar(false)
    setShowcamera(true)
  };
  const voltainit = () => {
    stopWebcam();
    setCapturedImage(null); // Reset captured image
    setShowfoto(false);
    setShowcamera(false);
    setShowvisualizar(false)
    setShowinit(true);
  }
  const enviarfoto = () =>{
    saveFile(capturedImage, orcamento)
  }
  useEffect(() => {    
    const init = document.querySelectorAll("div[id=divinit]");          
    const camera = document.querySelectorAll("div[id=divcamera]");   
    const foto = document.querySelectorAll("div[id=divfoto]");     
    const visualiza = document.querySelectorAll("div[id=visualiza]");  
      if (showcamera === true){
        camera[0].setAttribute('style', 'display:block');
      }else{
        camera[0].setAttribute('style', 'display:none');
      } 
      if (showinit === true){
        init[0].setAttribute('style', 'display:block');
      }else{
        init[0].setAttribute('style', 'display:none');
      }       
      if (showfoto === true){
        foto[0].setAttribute('style', 'display:block');
      }else{
        foto[0].setAttribute('style', 'display:none');
      } 
      if (showvisualizar === true){
        visualiza[0].setAttribute('style', 'display:block');
      }else{
        visualiza[0].setAttribute('style', 'display:none');
      }       
      if(!getQuantfiles){
        QuantFiles(orcamento)
        visualizar()
      }                 
  }); 
  const visualizar = () => {
    setShowvisualizar(true)
    setTimeout(() => {
      setShowLoading(true)
      setGetquantfiles(true)
      api.get('Getimgdown?Orcamento='+orcamento+'&foto='+nfoto+'&Origem=Entrada',{headers})
      .then(response => {
            if (response.data.length > 0 ){   
                setShowLoading(false)   
                const blob = new Blob([response.data], { type: 'image/jpg' })
                setUrl('data:image/jpg;base64,'+response.data)
                
            }else{
                setShowLoading(false)
            }                                   
      });
    }, 10 );       
  }  
  const sentido = (direcao: string) => {
    let nCont = nfoto
    if (direcao === "next") {
      if(nfoto < quantfiles) {
        nCont = nfoto + 1
        setNfoto(nCont)
        setGetquantfiles(false)
      }
    }
    if (direcao === "back") {
      if(nfoto <= quantfiles) {
        if(nfoto > 1){
          nCont = nfoto - 1
          setNfoto(nCont)
          setGetquantfiles(false)
        }else{
          setNfoto(1)
        }  
      }
    }    
  }
  return (
    <>
    <Navigation />    
    <Container>
    <div className="mt-2">    
      <div id="divinit" className="init-page mb-4">
        <div>
          <label>Orçamento: {orcamento}</label>
        </div>
        <div>
          <label>Quantidade de fotos: {quantfiles}</label>
        </div>        
        <div>
          <button onClick={startWebcam}>Fotos <MdAddAPhoto size={50} /></button>
          {/* {quantfiles > 0 ?
            (<button className="ms-4" onClick={() => visualizar()}>Visualizar <ImFilePicture size={50} /></button>): ('')
          } */}
          
        </div>
      </div> 

      <div id="divcamera">
        <div>
          <video className="w-100" ref={videoRef} autoPlay muted />
        </div>
        <div>
          <button className="me-4" onClick={captureImage}><MdOutlinePhotoCamera size={50} /> Foto </button>
          <button onClick={voltainit}><RiArrowGoBackLine size={50} /> Voltar </button>
        </div>
      </div>  

      <div id="divfoto" >
        {capturedImage ? (
          <div>
            <img src={capturedImage} className="w-100" />
            <button className="mt-2 me-5" onClick={resetState}><RiArrowGoBackLine size={50} /> Voltar </button>
            <button className="mt-2" onClick={enviarfoto}><BsFillSendArrowUpFill  size={50} /> Enviar </button>
          </div>
        ) : (
          <>
            <canvas ref={canvasRef} />
          </>
        )}
      </div>     
    </div>
    <div id="visualiza">
      <div className="mb-2">
        <Image style={{width: 350, height: 450}} src={url}/>
      </div>
        <div className="ps-2">
          <button className="me-5 btn btn-outline-primary" onClick={() => sentido('back')}> Anterior <IoIosSkipBackward  size={50} /></button>
          <button className="btn btn-outline-success" onClick={() => sentido('next')}><GiNextButton  size={50} /> Proxima </button>
        </div>
      </div>       
    <Spinner isLoading={ShowLoading} />
    </Container>
    </>
  );
};

export default WebcamCapture;